import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { __ } from '../../../../helpers/translations';

function SelectReleaseMode({ initialReleaseMode, onChange }) {
  const [releaseMode, setReleaseMode] = useState(initialReleaseMode);

  const changeReleaseMode = (value) => {
    setReleaseMode(value);
    onChange(value);
  };

  return (
    <>
      <p className="fw-bold">{__('G139')}</p>
      <Form.Group>
        <Form.Check
          value={releaseMode || ''}
          type="radio"
          label={(
            <div onClick={() => changeReleaseMode('default')} style={{ cursor: 'pointer' }}>
              <div>{__('G140')}</div>
              <div className="fw-light">{__('G141')}</div>
            </div>
              )}
          onChange={() => changeReleaseMode('default')}
          checked={releaseMode === 'default'}
          onClick={() => changeReleaseMode('default')}
        />
        <Form.Check
          value={releaseMode || ''}
          type="radio"
          label={(
            <div onClick={() => changeReleaseMode('review')} style={{ cursor: 'pointer' }}>
              <div>{__('G142')}</div>
              <div className="fw-light">{__('G143')}</div>
            </div>
              )}
          onChange={() => setReleaseMode('review')}
          checked={releaseMode === 'review'}
          onClick={() => changeReleaseMode('review')}
        />
      </Form.Group>
    </>
  );
}

SelectReleaseMode.propTypes = {
  initialReleaseMode: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectReleaseMode;
